// Call to Action component
import React from "react";
import '../styles/CTA.css';
import { ContactForm } from "./CTAForm";

function CTA (){
    return (
        <div className="cta-component">
            <div className="cta">
                <h2>Interested? Get In Touch!</h2>
                <div className="cta-content">
                    <div className="cta-location">
                        <div className="cta-info">
                            <div className="zambia-location">
                                <img className="zambian-flag" src="/images/zambia flag.png" alt="zambian flag"/>
                                <div className="zambia-location-info">
                                    <p>215D Napsa Complex, Off Buluwe Rd Lusaka Zambia</p>
                                    <p>Tel.: +260 760131924 | +260 955039262</p>
                                </div>
                            </div>
                            <div className="kenya-location">
                                <img className="kenyan-flag" src="/images/kenya flag.png" alt="kenyan flag"/>
                                <div className="kenya-location-info">
                                    <p>Pinetree Plaza, 8th Floor, Kaburu Drive, Ngong Road,</p>
                                    <p>P.O Box 100798-00100, Nairobi, Kenya</p>
                                    <p>Office Landline: +254204938470</p>
                                    <p>Mobile: +254 703 785199</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cta-form-container">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CTA;